import React from 'react';
import PropTypes from 'prop-types';

const FormHeader = (props) => {
  const { title, children, titleClassName, actionsClassName } = props;

  return (
    <div className="form-header">
      <div className={`title ${titleClassName}`}>{title}</div>
      <div className={actionsClassName}>{children}</div>
    </div>
  );
};

export default FormHeader;

FormHeader.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  actionsClassName: PropTypes.string,
  titleClassName: PropTypes.string,
};

FormHeader.defaultProps = {
  children: null,
  actionsClassName: 'form-actions',
  titleClassName: 'title-big',
};
